import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IIdentityUser } from '../models/identity-user.model';
import { ConfigurationService } from './configuration.service';
import { DataService } from './data.service';
import { SecurityService } from './security.service';

@Injectable()
export class IdentityService {
  private identityUrl = '';
  constructor(
    private dataService: DataService,
    private configurationService: ConfigurationService,
    private securityService: SecurityService
  ) {
    if (this.configurationService.isReady) {
      this.identityUrl = `${this.configurationService.serverSettings.identityUrl}/api/v1`;
    } else {
      this.configurationService.settingsLoaded$.subscribe((x) => {
        this.identityUrl = `${this.configurationService.serverSettings.identityUrl}/api/v1`;
      });
    }
  }

  public acceptTOS() {
    const url = `${this.identityUrl}/identity/tos`;
    const user = this.securityService.GetUser();
    const result = this.dataService.putWithId(url, null);
    result.subscribe(() => {
      user.accepted_tos = true;
      this.securityService.SetUser(user);
    });
  }

  public acceptCookiePolicy() {
    const url = `${this.identityUrl}/identity/cookie`;
    const user = this.securityService.GetUser();
    const result = this.dataService.putWithId(url, null);
    result.subscribe(() => {
      user.accepted_cookie = true;
      this.securityService.SetUser(user);
    });
  }
}
